// frontend/src/config/queryClient.ts
import { QueryClient, keepPreviousData } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,       // en v5 es gcTime (antes cacheTime)
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,        // o 'always' | true según necesites
      retry: 1,
      retryDelay: 1000,
      // ⬇️ reemplazo del viejo keepPreviousData: true
      placeholderData: keepPreviousData,
    },
    mutations: {
      retry: 0,
    },
  },
});
